var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 897.6c-108 0-209.6-42.4-285.6-118.4-76-76-118.4-177.6-118.4-285.6 0-108 42.4-209.6 118.4-285.6 76-76 177.6-118.4 285.6-118.4 108 0 209.6 42.4 285.6 118.4 157.6 157.6 157.6 413.6 0 571.2-76 76-177.6 118.4-285.6 118.4z m0-760c-95.2 0-184.8 36.8-252 104-67.2 67.2-104 156.8-104 252s36.8 184.8 104 252c67.2 67.2 156.8 104 252 104 95.2 0 184.8-36.8 252-104 139.2-139.2 139.2-364.8 0-504-67.2-67.2-156.8-104-252-104z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.872 329.392L348.096 689.16l-31.68-31.68 359.776-359.768z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 340.8l32-31.2 348 348-32 32z",
    fill: ""
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    id: "paperplane"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperplane"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperplane_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8843 42.1715L21.9423 30.6455C21.7247 30.1379 21.9597 29.55 22.4673 29.3323C22.9749 29.1147 23.5628 29.3498 23.7805 29.8573L28.7228 41.384C29.0908 42.2441 30.3272 42.1928 30.6227 41.3051L41.9447 7.34519C42.2101 6.54895 41.4519 5.79069 40.6556 6.05612L6.69795 17.374C5.80783 17.671 5.75653 18.9085 6.61925 19.2782L21.0984 25.4822L37.7432 8.84319C38.1338 8.45274 38.767 8.45285 39.1574 8.84344C39.5479 9.23403 39.5478 9.8672 39.1572 10.2577L22.0332 27.3757C21.725 27.6837 21.2659 27.7486 20.8941 27.5705L5.83148 21.1166C3.27863 20.0225 3.43062 16.3559 6.06521 15.4767L40.0232 4.15874C42.3829 3.37215 44.6287 5.61789 43.8421 7.9777L32.5202 41.9373C31.6435 44.5703 27.9759 44.7225 26.8843 42.1715Z"
  }))))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "minus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12L18 12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "pencil"
  }, /*#__PURE__*/React.createElement("title", null, "pencil"), /*#__PURE__*/React.createElement("path", {
    d: "M0 32l12-4 20-20-8-8-20 20zM4 28l2.016-5.984 4 4zM8 20l12-12 4 4-12 12z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "done"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L10.4142 17C9.63316 17.7811 8.36683 17.781 7.58579 17L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12H20M12 4V20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.5e1bedc90c1185667144fac677bb9736.svg";
export { ForwardRef as ReactComponent };